export const DetailsSection = ({ title, description, secondTitle, items }) => (
  <section className="section-sp2 hcp-details">
    <div
      className="container inner-content"
      style={{ maxWidth: "810px", margin: "0 auto" }}
    >
      <h1 className="text-center">{title}</h1>
      <p
        className="text-center "
        dangerouslySetInnerHTML={{ __html: description }}
      ></p>
    </div>

    <div className="container">
      <div className="row align-items-center">
        <div className="text-center col-md-10 col-sm-12  mx-auto">
          <h2 className="title-ext text-primary">{secondTitle}</h2>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row row-cols-auto gy-3 justify-content-center">
        {items.map((item) => (
          <div className="" key={item.id}>
            <div className="feature-container feature-bx1 feature1">
              <div className="icon-md">
                <span className="icon-cell"></span>
              </div>
              <div className="icon-content">
                <h4 className="ttr-title">{item.label}</h4>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
